import { render, staticRenderFns } from "./Regle.vue?vue&type=template&id=a8932b24&scoped=true&"
import script from "./Regle.vue?vue&type=script&lang=js&"
export * from "./Regle.vue?vue&type=script&lang=js&"
import style0 from "./Regle.vue?vue&type=style&index=0&id=a8932b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8932b24",
  null
  
)

export default component.exports